import { IconClose } from '@blockchain-com/icons'
import Logo from 'assets/images/logo-blockchain.svg'
import Icon from 'components/Icons/Icon'
import Link from 'components/Link'
import { iosAppStoreUrl } from 'constants/appStore'
import { actions } from 'data'
import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { Copy, Img as BaseImg, Wrapper } from './styles'

const Close = styled(IconClose)`
  align-self: center;
`

const Img = styled(BaseImg)`
  border-radius: 15px;
`

const Button = styled(Link)`
  align-self: center;
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: #367af6;
  padding-right: 8px;

  :hover {
    color: #367af6;
    text-decoration: none;
  }
`

const IOSMobileBanner = ({ onClose }) => {
  const dispatch = useDispatch()
  return (
    <Wrapper>
      <Icon color='grey400'>
        <Close
          onClick={() => {
            dispatch(
              actions.analytics.trackEvent({
                key: 'Mobile Web Banner Closed',
                properties: {
                  mobile_os: 'IOS'
                }
              })
            )
            onClose()
          }}
        />
      </Icon>
      <Img src={Logo} />
      <Copy>
        <p>Blockchain Exchange</p>
        <small>Blockchain.com</small>
        <caption>GET — On the Play Store</caption>
      </Copy>
      <Button
        onClick={() => {
          dispatch(
            actions.analytics.trackEvent({
              key: 'Mobile Web Banner Clicked',
              properties: {
                mobile_os: 'IOS'
              }
            })
          )
          window.open(iosAppStoreUrl)
        }}
      >
        View
      </Button>
    </Wrapper>
  )
}

export default IOSMobileBanner
